module.exports = __webpack_public_path__ + "img/truck.2a7b132f.svg";